<template>
	<div class="w-full">
		<GridLayout
			class="p-3"
			:reactiveSidebar="false"
			:sidebarState="false"
		>
			<template #right-header>
				<Title value="PAGAMENTO" />
			</template>
			<template #right-tool-bar>
				<div class="w-full flex justify-between tool-bar">
					<div class="flex gap-5">
						<div class="flex items-center py-1"></div>
					</div>
					<div class="flex gap-5">
						<div class="flex items-center">
							<button class="new-config">
								<i class="fal fa-plus font-32"></i>
							</button>
						</div>
					</div>
				</div>
			</template>
			<template #right-content> </template>
			<template #right-footer>
				<div
					class="w-full h-full py-2 flex justify-between mx-5 items-center gap-3"
				>
					<button class="btn btn-danger btn-fixed-size">
						DELETAR
					</button>
					<button class="btn btn-success btn-fixed-size">
						SALVAR
					</button>
				</div>
			</template>
		</GridLayout>
	</div>
</template>

<script>
	import _ from 'lodash'
	import Swal from 'sweetalert2'
	import { mapGetters, mapActions } from 'vuex'

	export default {
		name: 'Payments',
		components: {},
		data() {
			return {}
		},
		computed: {
			...mapGetters('auth', ['requester_selected_id']),
		},
		watch: {},
		methods: {
			...mapActions('system', ['ToggleShowSidebar']),
		},
		beforeMount() {
			this.ToggleShowSidebar(false)
		},
	}
</script>

<style lang="scss" scoped>
	.text-primary {
		color: var(--newPrimaryBackgroundColor) !important;
	}

	.text-muted {
		color: var(--fontColorLighter) !important;
	}

	.btn {
		padding: 0.7rem 1rem;
		color: var(--white);
		outline: none;
		background-color: var(--newPrimaryBackgroundColor);
		border: 1px solid var(--newPrimaryBackgroundColor);
		border-radius: 0.3rem;
		transition: all 0.1s ease-in-out;
		height: unset;

		display: flex;
		align-items: center;
		justify-content: center;

		&:hover {
			background-color: var(--newPrimaryDark);
			border-color: var(--newPrimaryDark);
			color: var(--white);
		}

		&.btn-unshaped {
			padding: unset;
			background-color: unset;
			border: unset;
		}

		&.btn-success {
			background-color: var(--successBackgroundColor);
			border-color: var(--successBackgroundColor);

			&:hover {
				background-color: var(--successHoverBackgroundColor);
				border-color: var(--successHoverBackgroundColor);
			}
		}

		&.btn-danger {
			background-color: red;
			border-color: red;

			&:hover {
				background-color: #6f0202;
				border-color: #6f0202;
			}
		}

		&.btn-outline-danger {
			color: red;

			&:hover {
				i {
					font-weight: 900;
				}
			}

			&:active {
				background-color: unset;
				border: unset;
				color: red;

				i {
					font-weight: 900;
				}
			}
		}

		&:disabled {
			background-color: #aaa;
		}
	}

	.main-content {
		height: 72.6vh;
	}

	.tool-bar {
		padding: 0.4rem 0;
		border-bottom: 1px solid var(--hr);

		.btn {
			padding: 0.3rem 0.6rem;

			&.has-filters {
				background-color: var(--has-filters);
				border: 1px solid var(--has-filters);
				color: var(--white) !important;
				text-shadow: 0px 0px 7px var(--white);
				box-shadow: none;

				&:hover,
				&:active,
				&:focus {
					background-color: var(--has-filters-hover);
					border-color: var(--has-filters-hover);
					color: var(--white) !important;
				}
			}
		}

		.messages-switch {
			padding: 0.5rem;
			background-color: var(--backgroundLight);
			border: 1px solid var(--backgroundLight);
			border-radius: 0.5rem;

			color: var(--fontColor);

			.font-40 {
				line-height: 1;
			}
		}

		.new-config {
			padding: 0.3rem 0.6rem;
			color: var(--white);
			outline: none;
			background-color: var(--newPrimaryBackgroundColor);
			border: 1px solid var(--newPrimaryBackgroundColor);
			border-radius: 50% !important;
			transition: background 0.1s ease-in-out;

			&:hover {
				background-color: var(--newPrimaryDark);
				border-color: var(--newPrimaryDark);
			}
		}
	}

	.select-all-container {
		.form-check span {
			line-height: 1;
		}
	}

	.form-check {
		display: flex;
		align-items: center;

		input:checked ~ label:after {
			font-family: 'Font Awesome 5 Pro';
			content: '\f00c';
			font-weight: 400;
			padding: 0.1rem 0.3rem;
			font-size: 1.3rem;
			color: #fff;
			top: 0;
			left: 0;
			position: absolute;
			width: 2rem;
			height: 2rem;
			background: var(--newPrimaryBackgroundColor);
			border-radius: 0.5rem;
		}

		.form-check-label {
			position: relative;
			width: 2rem;
			height: 2rem;
			padding: 0;

			&:before {
				width: 2rem;
				height: 2rem;
				background: var(--inputBackgroundLight);
			}
		}

		&:hover {
			label:before {
				background: var(--inputBackgroundLighter);
			}
		}
	}

	.configs-container {
		display: flex;
		flex-direction: column;
		gap: 1rem;

		.config-wrapper {
			.config-container {
				background-color: var(--backgroundLight);
				color: var(--fontColor);
				border-radius: 1rem;
				cursor: pointer;

				&:hover {
					background-color: var(--newPrimaryDark);
					color: #fff;

					.text-muted {
						color: #fff !important;
					}
				}
			}
		}
	}
</style>
